<template>
<div>
<h2>Stranka</h2>
<p v-if="pridelovalec.kmgmid">
{{kontakt.naziv}} ({{pridelovalec.kmgmid}}), {{kontakt.naslov}}, {{kontakt.postnastevilka}} {{kontakt.posta}} 
</p>
<p v-else>
  {{kontakt.naziv}},	{{kontakt.naslov}}, {{kontakt.postnastevilka}} {{kontakt.posta}} 
  
</p>

<shemaCommandCell v-if="pridelovalec" :ukazi="ukazi" :dataItem="pridelovalec" :shema="shema" :sezona="sezona"/>
<shemaCommandCell v-if="pridelovalec&&kontrolaid" :ukazi="ukazikontrola" :dataItem="pridelovalec" :shema="shema" :sezona="sezona" :podshema="podshema"  :kontrolaid="kontrolaid"/>


<button v-if="user.pravice.includes('admin')" class="k-button k-primary"  @click="urediStranko">Uredi podatke o stranki</button>


</div>
</template>
<script>
import { mapState} from 'vuex'
import ShemaCommandCell from './ShemaCommandCell';

/*

<div>
 <shemaCommandCell :ukazi="ukazi" :dataItem="pridelovalec"/>
</div>

*/

export default {
    props: {
      pridelovalec:Object,
      shema:String,
      sezona:Number,
      podshema:String,
      kontrolaid:String,
    },
    components:{
      'shemaCommandCell': ShemaCommandCell,
    },
    computed: {
      
      ...mapState('account', ['user']),
      ...mapState('users', ['sheme']),
        ukazi:{
          get(){
           if(this.sheme&&Array.isArray(this.sheme)&&this.sheme.length>0)
              return this.sheme.find(i=>i.kratica==this.shema)?.ukazi;
            else
              return [];
          }
        },
        ukazikontrola:{
          get(){
            if(this.sheme&&Array.isArray(this.sheme)&&this.sheme.length>0&&this.kontrolaid)
              return this.sheme.find(i=>i.kratica==this.shema)?.ukazikontrole;
            else
              return [];
          }
        },
        kontakt:{
            get(){
                var kontakt=this.pridelovalec?.kontakt?.find(k=>k.glavni);
                if(!kontakt)
                kontakt=this.pridelovalec?.kontakt?.find(k=>k.vloga=='nosilec kmg');
                if(!kontakt)
                kontakt=this.pridelovalec?.kontakt[0];

                return kontakt;
            }
        },
      },
    methods:{
      urediStranko: function() {
           //this.select({pridelovalec:this.dataItem});
           console.log(this.pridelovalec)
           
           this.$router.push({ name: 'dodajStranko', params: { strankaid:this.pridelovalec._id } })
            
        },
      },
    
  
  
  created(){
  	console.log(this.pridelovalec);
  }
}
</script>